import { createHomologationItemGuard } from '@/entities/Document';
import { VERIFICATION_ITEM_MESSAGES } from '@/features/verification';

/** Keeps an item already decided by someone else from opening its verification screen. */
export const verificationItemGuard = createHomologationItemGuard({
  stage: 'verification',
  listPath: '/verificacao',
  messages: VERIFICATION_ITEM_MESSAGES,
});
